/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('jquery'),
            require('cookies-js'),
            require('./fp_canvas_model'),
            require('./fp_font_model'),
            require('./fp_display_model'),
            require('./fp_browser_model'),
            require('./fp_persistent_model'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define([
            'backbone',
            'jquery',
            './fp_canvas_model',
            './fp_font_model',
            './fp_display_model',
            './fp_browser_model',
            './fp_persistent_model',
        ], function (
            Backbone,
            $,
            FpCanvasModel,
            FpFontModel,
            FpDisplayModel,
            FpBrowserModel,
            FpPersistentModel,
        ) {
            return factory(
                Backbone,
                $,
                {
                    get: $.cookie,
                    set: $.cookie,
                },
                FpCanvasModel,
                FpFontModel,
                FpDisplayModel,
                FpBrowserModel,
                FpPersistentModel,
            );
        });
    }
})(this, function (
    Backbone,
    $,
    Cookies,
    FpCanvasModel,
    FpFontModel,
    FpDisplayModel,
    FpBrowserModel,
    FpPersistentModel,
) {
    'use strict';

    function getCSRFToken() {
        return Cookies.get('csrftoken');
    }

    return Backbone.Model.extend({
        config: {
            url: '/ajax/fp',
            version: 1,
        },

        initialize: function (options) {
            this.options = options;
            this.featureModels = [
                new FpCanvasModel(),
                new FpFontModel(),
                new FpDisplayModel(),
                new FpBrowserModel(),
            ];
            this.persistentModel = new FpPersistentModel();
        },

        generate: function () {
            var startTime = Date.now(),
                $deferred = new $.Deferred(),
                $persistentPromise = this.persistentModel.getHash(),
                hash = this.featureModels.reduce(function (memo, model) {
                    return memo + ':' + model.getFeatures().join(':');
                }, this.config.version),
                endTime = Date.now();

            $persistentPromise.done(
                function (persistentResults) {
                    $deferred.resolve({
                        data: hash,
                        data2: persistentResults.value,
                        fpid: this.options.fpid,
                        pt: persistentResults.tampered,
                        time: endTime - startTime,
                    });
                }.bind(this),
            );

            return $deferred.promise();
        },

        save: function () {
            this.generate().done(
                function (data) {
                    $.ajax({
                        type: 'POST',
                        url: this.config.url,
                        data: data,
                        headers: {
                            'X-CSRFToken': getCSRFToken(),
                        },
                    });
                }.bind(this),
            );
        },
    });
});
